import { Component, AfterViewInit } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CountryPhoneCodes } from '@app/components/interface/country-phone-codes';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ToastService } from '@app/services/toast.service';
import { ToastrService } from 'ngx-toastr';
interface Slides {
  image: string;
  title: string;
  description: string;
}
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrl: './forgotpassword.component.scss'
})
export class ForgotpasswordComponent implements AfterViewInit {
  phoneForm: FormGroup;

  // State
  step: 'phone' | 'otp' = 'phone';
  loading = false;
  showToast = false;
  toastMessage = '';
  phoneNumber = '';
  otp = ['', '', '', '', '', ''];
  showCountryCode = true;
  inputType: 'phone' | 'email' = 'phone';
  private _otpProcessing = false; // guard to prevent re-entrant handling
  // Resend OTP Timer
  resendOtpTimer = 0;
  resendOtpTimerInterval: any = null;
  isResendOtpDisabled = false;
  // Slider
  currentSlide = 0;
  slideInterval: any;
  slides: Slides[] = [
    {
      image: '../../../../assets/images/banner_1.png',
      title: 'Track Every Delivery',
      description: 'Real-time GPS tracking for complete visibility'
    },
    {
      image: '../../../../assets/images/banner_2.png',
      title: 'Optimize Routes',
      description: 'AI-powered routing for faster deliveries'
    },
    {
      image: '../../../../assets/images/banner_3.png',
      title: 'Smart Analytics',
      description: 'Make data-driven decisions with insights'
    },
    {
      image: '../../../../assets/images/banner_4.png',
      title: 'Happy Customers',
      description: 'Deliver exceptional service every time'
    },
    {
      image: '../../../../assets/images/banner_5.png',
      title: 'Seamless Management',
      description: 'Centralized control for your entire fleet'
    }
  ];

  // Country codes
  countryCodes = CountryPhoneCodes;

  constructor(
    private fb: FormBuilder,
    private router: Router, private authService: AuthServiceService, private toastr: ToastrService, private toast: ToastService, private sharedData: ShareddtaService
  ) {
    const savedCountryCode = localStorage.getItem('countryCode');
    this.phoneForm = this.fb.group({
      countryCode: [savedCountryCode, Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
    });
    // Ensure validators match initial content
    this.onPhoneNumberChange();
  }

  ngAfterViewInit(): void {
    this.sharedData.signalPageReady();
  }

  ngOnInit(): void {
    this.startSlider();
  }

  ngOnDestroy(): void {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  // Slider
  startSlider(): void {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  }

  prevSlide(): void {
    this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.resetSlider();
  }

  resetSlider(): void {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
    this.startSlider();
  }

  // Phone
  onSendOtp(): void {
    if (this.phoneForm.invalid) {
      Object.keys(this.phoneForm.controls).forEach(key => {
        this.phoneForm.get(key)?.markAsTouched();
      });
      return;
    }

    this.loading = true;
    const formData = this.phoneForm.value;
    this.phoneNumber = `${formData.countryCode} ${formData.phoneNumber}`;
    if (this.inputType === 'email') {
      this.phoneNumber = formData.phoneNumber?.trim();
      this.phoneNumber = `${formData.phoneNumber}`;
      const storedEmail = this.authService.getLS('org_email');
      const submittedInput = String(this.phoneForm.get('phoneNumber')?.value ?? '');
      if (submittedInput !== storedEmail) {
        this.toast.show('error', "The email you entered doesn't match our records. Please check and enter the correct email.");
        this.loading = false;
        return; // Stop the process if phone numbers do not match
      }
      this.loading = true;
      this.authService.setMobileNumber(String(this.phoneForm.get('phoneNumber')?.value ?? ''));
      this.authService.setCountryCode(String(this.phoneForm.get('countryCode')?.value ?? ''));;

      this.authService.sendResetOtp(String(this.phoneForm.get('phoneNumber')?.value ?? '')).subscribe(
        (data: any) => {
          this.loading = false;
          if (this.authService.resultCodeError(data)) {
            this.loading = false;
            return;
          }

          this.toast.show('success', data?.message);

          setTimeout(() => {
            this.loading = false;
            this.step = 'otp';
            this.startResendOtpTimer();

            setTimeout(() => {
              document.getElementById('otp1')?.focus();
            }, 100);
          }, 1000);
          this.loading = false;
        },
        (error) => {
          this.authService.dataError(error);
          this.loading = false;
        }
      );
    } else {
      this.phoneNumber = `${formData.countryCode} ${formData.phoneNumber}`;
      const storedPhoneNumber = this.authService.getLS('adminPhoneNumber');
      const submittedInput = String(this.phoneForm.get('phoneNumber')?.value ?? '');
      if (submittedInput !== storedPhoneNumber) {
        this.toast.show('error', "The phone number you entered doesn't match our records. Please check and enter the correct phone number.");
        this.loading = false;
        return; // Stop the process if phone numbers do not match
      }
      this.loading = true;
      this.authService.setMobileNumber(String(this.phoneForm.get('phoneNumber')?.value ?? ''));
      this.authService.setCountryCode(String(this.phoneForm.get('countryCode')?.value ?? ''));;

      this.authService.sendResetOtp(String(this.phoneForm.get('phoneNumber')?.value ?? ''), String(this.phoneForm.get('countryCode')?.value ?? '')).subscribe(
        (data: any) => {
          this.loading = false;
          if (this.authService.resultCodeError(data)) {
            this.loading = false;
            return;
          }
          this.toast.show('success', data?.message);

          setTimeout(() => {
            this.loading = false;
            this.step = 'otp';
            this.startResendOtpTimer();

            setTimeout(() => {
              document.getElementById('otp1')?.focus();
            }, 100);
          }, 1500);
          this.loading = false;
        },
        (error) => {
          this.authService.dataError(error);
          this.loading = false;
        }
      );
    }
  }

  // Phone Number Input Handler
  onPhoneNumberChange(): void {
    const phoneControl = this.phoneForm.get('phoneNumber');
    const phoneValue = phoneControl?.value || '';
    // Hide country code if any alphabet is typed, show only if empty or numbers only
    const hasAlphabet = /[a-zA-Z]/.test(phoneValue);
    this.showCountryCode = !hasAlphabet;
    // Set input type based on content
    this.inputType = hasAlphabet ? 'email' : 'phone';

    // Update validators dynamically based on input type
    if (phoneControl) {
      if (this.inputType === 'email') {
        phoneControl.setValidators([Validators.required, Validators.email]);
      } else {
        phoneControl.setValidators([Validators.required, Validators.pattern(/^[0-9]{10}$/)]);
      }
      phoneControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
  }

  // OTP
  otpTouched = false;

  get isOtpInvalid(): boolean {
    return this.otpTouched && this.otp.some(d => d === '');
  }
  onOtpInput(event: any, index: number): void {
    if (this._otpProcessing) return; // ignore if we're already handling an event
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // ignore programmatic input events
    if ((input.dataset as any).programmatic) {
      delete (input.dataset as any).programmatic;
      return;
    }

    // Normalize: keep only the last character if multiple entered
    if (!value) {
      input.value = '';
      this.otp[index] = '';
      return;
    }
    if (value.length > 1) {
      value = value.slice(-1);
      input.value = value;
    }

    // Allow only single digit
    if (!/^[0-9]$/.test(value)) {
      input.value = '';
      this.otp[index] = '';
      return;
    }

    // mark as processing to prevent duplicate handling
    this._otpProcessing = true;
    this.otp[index] = value;

    // Move to next input (deferred to avoid double-fill due to key events)
    if (index < this.otp.length - 1) {
      setTimeout(() => document.getElementById(`otp${index + 2}`)?.focus(), 0);
    }

    // Auto verify when all digits filled
    if (this.otp.every(digit => digit !== '')) {
      // this.verifyOtp();
    }

    // release processing flag shortly after
    setTimeout(() => { this._otpProcessing = false; }, 100);
  }

  onOtpKeydown(event: KeyboardEvent, index: number): void {
    const key = event.key;

    // Allow Tab navigation
    if (key === 'Tab') {
      return;
    }

    // Handle Backspace
    if (key === 'Backspace') {
      event.preventDefault();
      this.otp[index] = '';

      if (index > 0) {
        document.getElementById(`otp${index}`)?.focus();
      }
      return;
    }

    // Allow only digits
    if (/^[0-9]$/.test(key)) {
      event.preventDefault();

      // ✅ ONLY update model
      this.otp[index] = key;

      // ✅ move focus
      if (index < this.otp.length - 1) {
        setTimeout(() => {
          document.getElementById(`otp${index + 2}`)?.focus();
        }, 0);
      }

      // Auto verify
      if (this.otp.every(d => d !== '')) {
        this.verifyOtp();
      }
    }
  }


  onOtpPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text');

    if (pastedData && /^\d{6}$/.test(pastedData)) {
      const digits = pastedData.split('');
      digits.forEach((digit, index) => {
        this.otp[index] = digit;
        const input = document.getElementById(`otp${index + 1}`) as HTMLInputElement;
        if (input) {
          input.value = digit;
        }
      });

      this.verifyOtp();
    }
  }

  verifyOtp(): void {
    this.otpTouched = true;
    const otpValue = this.otp.join('');

    if (otpValue.length !== 6) {
      return;
    }

    this.loading = true;
    if (this.inputType == 'email') {
      this.authService
        .verifyResetOtp(this.phoneNumber, otpValue)
        .subscribe(
          (data: any) => {
            if (this.authService.resultCodeError(data)) {
              this.loading = false;
              return;
            }
            this.toast.show('success', data.message);
            this.router.navigate(['/verify-password']);
          },
          (error) => {
            this.authService.dataError(error);
            this.loading = false;
          }
        );
    }

    if (this.inputType != 'email') {
      this.authService
        .verifyResetOtp(String(this.phoneForm.get('phoneNumber')?.value ?? ''), otpValue, String(this.phoneForm.get('countryCode')?.value ?? ''))
        .subscribe(
          (data: any) => {
            if (this.authService.resultCodeError(data)) {
              this.loading = false;
              return;
            }

            this.toast.show('success', data.message);
            this.router.navigate(['/verify-password']);
          },
          (error) => {
            this.authService.dataError(error);
            this.loading = false;
          }
        );
    }

    // setTimeout(() => {
    //   this.loading = false;

    //   if (otpValue.length === 6) {
    //     this.showSuccessToast('OTP Send!');
    //     this.router.navigate(['/verify-password']);
    //     // setTimeout(() => {
    //     //   this.router.navigate(['/auth/organization']);
    //     // }, 1000);
    //   }
    // }, 1500);
  }

  onResendOtp(): void {
    this.loading = true;
    this.onSendOtp();
    // setTimeout(() => {
    //   this.loading = false;
    //   this.showSuccessToast('OTP resent successfully!');
    //   this.clearOtp();
    //   document.getElementById('otp1')?.focus();
    // }, 1000);
  }

  clearOtp(): void {
    this.otp = ['', '', '', '', '', ''];
    for (let i = 1; i <= 6; i++) {
      const input = document.getElementById(`otp${i}`) as HTMLInputElement;
      if (input) {
        input.value = '';
      }
    }
  }

  goBackToPhone(): void {
    this.step = 'phone';
    this.clearOtp();
  }



  // Form helpers
  get phoneNumberControl() {
    return this.phoneForm.get('phoneNumber');
  }

  get hasPhoneError(): boolean {
    const control = this.phoneNumberControl;
    return !!(control && control.invalid && control.touched);
  }

  get phoneErrorMessage(): string {
    if (this.inputType === 'email') {
      return 'Please enter a valid email address';
    }
    return 'Please enter a valid 10-digit phone number';
  }
  goBack() {
    this.router.navigate(['/login']);
  }
  // ========== RESEND OTP TIMER METHODS ==========
  startResendOtpTimer(): void {
    this.resendOtpTimer = 60;
    this.isResendOtpDisabled = true;

    if (this.resendOtpTimerInterval) {
      clearInterval(this.resendOtpTimerInterval);
    }

    this.resendOtpTimerInterval = setInterval(() => {
      this.resendOtpTimer--;

      if (this.resendOtpTimer <= 0) {
        clearInterval(this.resendOtpTimerInterval);
        this.isResendOtpDisabled = false;
        this.resendOtpTimer = 0;
      }
    }, 1000);
  }

  getResendOtpTimerDisplay(): string {
    return this.resendOtpTimer.toString().padStart(2, '0');
  }
}
